import service from '../utils/Service'

export default function restoreSession(userId) {
   return {
      type : "RESTORE_SESSION",
      payload: service.restoreSession(userId)
   }
}




// WEBPACK FOOTER //
// ./src/actions/restoreSessionAction.js